import { render, staticRenderFns } from "./VisitorActionListMenu.vue?vue&type=template&id=ba56b990"
import script from "./VisitorActionListMenu.vue?vue&type=script&lang=js"
export * from "./VisitorActionListMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports